import { cn } from '@anytag/shared-utils';
import { SelectOption } from '@anytag/shared-types';
import { ComboboxLabel, ComboboxOption, ComboboxOptionProps } from '@anyui/core';
import { CheckBox } from '../../CheckBox';
import { TextCutter } from '../../TextCutter';
import { useSelectContext } from '../select-context';
import { getOptionLabel, getOptionValue } from '../utils';

interface SelectItemProps extends Pick<ComboboxOptionProps, 'active' | 'disabled'> {
  className?: string;
  option: SelectOption<string>;
}

export const SelectItem = ({ active, option, className, disabled }: SelectItemProps) => {
  const {
    selectProps: { multiple, classNames }
  } = useSelectContext();

  const optValue = getOptionValue(option);
  const optLabel = getOptionLabel(option);

  return (
    <ComboboxOption
      active={active}
      value={optValue}
      disabled={disabled}
      className={cn(className, classNames?.option)}
      keywords={typeof optLabel === 'string' ? [optLabel] : undefined}
    >
      {multiple ? <CheckBox checked={active} disabled={disabled} /> : option.prefixIcon}
      <ComboboxLabel className={classNames?.label}>
        <TextCutter text={optLabel} lines={1} />
      </ComboboxLabel>
    </ComboboxOption>
  );
};
